import { Mars, Venus, HelpCircle } from "lucide-react";

const getGenderDisplay = (gender) => {
  if (!gender)
    return { label: "N/A", icon: <HelpCircle className="w-5 h-5 text-gray-500" /> };

  const g = gender.toLowerCase();
  if (g === "m")
    return { label: "Male", icon: <Mars className="w-5 h-5 text-blue-600" /> };
  if (g === "f")
    return { label: "Female", icon: <Venus className="w-5 h-5 text-pink-600" /> };
  return { label: "N/A", icon: <HelpCircle className="w-5 h-5 text-gray-500" /> };
};

export default function GenderDisplay({ gender }) {
  const { label, icon } = getGenderDisplay(gender);

  return (
    <div className="flex items-center gap-2 text-lg font-semibold text-gray-900">
      {icon}
      <span>{label}</span>
    </div>
  );
}

// Usage:
{/* <GenderDisplay gender={transactionData?.gender} /> */}
